import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { routePath as RP } from "./routepath";
import PrivateRoute from "./PrivateRoute";
import LoginPage from "../../pages/auth/loginPage";
import UserManagementPage from "../../pages/user/userManagementPage";
import Dashboard from "../../pages/Dashboard/Dashboard";
import Layout from "../Layout/Layout";
import Users from "../../pages/Users/Users";
import AdminBlog from "../../pages/AdminBlogs/AdminBlogs";
import AddBlog from "../../pages/AdminBlogs/createBlog";
import UserBlog from "../../pages/Blog/UserBlog/UserBlog";
import ViewAdminBlog from "../../pages/AdminBlogs/ViewAdminBlog";
import EditBlog from "../../pages/AdminBlogs/EditBlog";
import AdminNewsletters from "../../pages/AdminNewsletters/AdminNewsletters";
import CreateAdminNewsletter from "../../pages/AdminNewsletters/CreateNewsletter";
import AdminArticle from "../../pages/AdminArticle/AdminArticle";
import ViewArticle from "../../pages/AdminArticle/ViewArticle";
import EditArticle from "../../pages/AdminArticle/EditArticle";
import EditNewsletter from "../../pages/AdminNewsletters/EditNewsletter";
import ViewNewsletter from "../../pages/AdminNewsletters/ViewNewsletter";
import NewsletterRgisteredEmail from "../../pages/RegisteredEmails/NewsLetterSubscriber";

import UserArticle from "../../pages/UserArticle/UserArticle";
import ArticleForm from "../../pages/AdminArticle/ArticleForm";
import UpdateReview from "../../pages/UpdateReqReviewPage/UpdateReview";
import NotFound from "../../pages/NotFound/NotFound";
import ForgotPassword from "../../pages/auth/ForgotPassword";
//  ChatBot imports
import ChatBotDashboard from "../../ChatBot Pages/Dashboard/ChatBot_Dashboard";
import User_Bot from "../../ChatBot Pages/Chats/User_Bot";
import User_Agent from "../../ChatBot Pages/Chats/User_Agent";
import UploadPdf from "../../NewChatBotPages/UploadPdf/UploadPdf";
import Documents from "../../NewChatBotPages/Documents/Documents";
import DeletedDocuments from "../../NewChatBotPages/DeletedDocuments/DeletedDocuments";
import ShowQuatrentDbChat from "../../ChatBot Pages/ShowQdrantQas/ShowQdrantQa";
import Show_DeletedQdrantQa from "../../ChatBot Pages/ShowDeletedQdrantQas/Show_DeletedQdrantQa";
import QuestionsAnswersPage from "../../ChatBot Pages/ShowQdrantQas/ShowQdrantQa";
import Profile from "../../pages/Profile/Profile";
import Technologies from "../../pages/TechnologyManagement/Technologies";
import ClientDetectionEmails from "../../NewChatBotPages/ShowClientDetectionEmails/ClientDetectionEmails";
import Features from "../../NewChatBotPages/features/Features"
import NewChatbotDashboard from "../../NewChatBotPages/Dashboard/NewChatBot_Dashboard";
import User_Bot_Chat from "../../NewChatBotPages/Chats/User_Bot";
import User_Agent_Chat from "../../NewChatBotPages/Chats/User_Agent";
import ClientDetails from "../../NewChatBotPages/ShowClientFullDetails/ClientDetails";
import Logs from "../../NewChatBotPages/Logs/Logs";

const AppRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={RP.login} replace />} />
      <Route path="*" element={<Navigate to={RP.notFound} replace />} />
      <Route path={RP.login} element={<LoginPage />} />
      <Route path={RP.notFound} element={<NotFound />} />
      <Route path={RP.forgotPassword} element={<ForgotPassword/>}/>

      <Route
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route
          path={RP.usersManagement}
          element={
            <PrivateRoute>
              <UserManagementPage />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.showClientDetectionEmails}
          element={
            <PrivateRoute>
              <ClientDetectionEmails/>
            </PrivateRoute>
          }
        />
        <Route
          path={RP.clientDetails}
          element={
            <PrivateRoute>
              <ClientDetails/>
            </PrivateRoute>
          }
        />
        <Route
          path={RP.systemLogs}
          element={
            <PrivateRoute>
              <Logs/>
            </PrivateRoute>
          }
        />
        <Route
          path={RP.showNewDashboard}
          element={
            <PrivateRoute>
              <NewChatbotDashboard/>
            </PrivateRoute>
          }
        />
        <Route
          path={RP.showFeatures}
          element={
            <PrivateRoute>
              <Features/>
            </PrivateRoute>
          }
        />
        <Route
          path={RP.userBotChats}
          element={
            <PrivateRoute>
              <User_Bot_Chat/>
            </PrivateRoute>
          }
        />
        <Route
          path={RP.userAgentChats}
          element={
            <PrivateRoute>
              <User_Agent_Chat/>
            </PrivateRoute>
          }
        />
        <Route
          path={RP.dashboard}
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.users}
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.Technologies}
          element={
            <PrivateRoute>
              <Technologies/>
            </PrivateRoute>
          }
        />
        <Route
          path={RP.adminBlogs}
          element={
            <PrivateRoute>
              <AdminBlog />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.AddBlog}
          element={
            <PrivateRoute>
              <AddBlog />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.editNewsletter}
          element={
            <PrivateRoute>
              <EditNewsletter />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.viewNewsletter}
          element={
            <PrivateRoute>
              <ViewNewsletter />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.userBlog}
          element={
            <PrivateRoute>
              <UserBlog />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.adminNewsletter}
          element={
            <PrivateRoute>
              <AdminNewsletters />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.addAdminNewsletter}
          element={
            <PrivateRoute>
              <CreateAdminNewsletter />
            </PrivateRoute>
          }
        />

        <Route
          path={RP.UpdateReview}
          element={
            <PrivateRoute>
              <UpdateReview />
            </PrivateRoute>
          }
        />

        {/* <Route path={RP.ViewAdminBlog} element={<ViewAdminBlog />} />
        <Route path={RP.editBlog}      element={<EditBlog />} />
        <Route path={RP.AdminArticle}  element={< AdminArticle/>} />
        <Route path={RP.ViewArticle}   element = {<ViewArticle/>} />
        <Route path={RP.editArticle}   element = {<EditArticle/>} />
        <Route path={RP.newsLetterSubscriber} element = {<NewsletterRgisteredEmail/>} />
        <Route path={RP.userArticle}   element = {<UserArticle/>}  />
        <Route path={RP.ArticleForm}   element = {<ArticleForm/>} /> */}
        {/* <Route path={RP.ReviewUpdates} element = {<UpdateReview/>} /> */}

        <Route
          path={RP.ViewAdminBlog}
          element={
            <PrivateRoute>
              <ViewAdminBlog />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.editBlog}
          element={
            <PrivateRoute>
              <EditBlog />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.AdminArticle}
          element={
            <PrivateRoute>
              <AdminArticle />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.ViewArticle}
          element={
            <PrivateRoute>
              <ViewArticle />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.editArticle}
          element={
            <PrivateRoute>
              <EditArticle />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.newsLetterSubscriber}
          element={
            <PrivateRoute>
              <NewsletterRgisteredEmail />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.userArticle}
          element={
            <PrivateRoute>
              <UserArticle />
            </PrivateRoute>
          }
        />
        <Route
          path={RP.ArticleForm}
          element={
            <PrivateRoute>
              <ArticleForm />
            </PrivateRoute>
          }
        />
        {/* <Route path={RP.ReviewUpdates} element = {<UpdateReview/>} /> */}

        {/* ChatBot Route */}

        <Route
          path={RP.chatBotDashboard}
          element={
            <PrivateRoute>
              <ChatBotDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path={RP.userAgentChats}
          element={
            <PrivateRoute>
              <User_Agent />
            </PrivateRoute>
          }
        />

        <Route
          path={RP.userBotChats}
          element={
            <PrivateRoute>
              <User_Bot />
            </PrivateRoute>
          }
        />

        <Route
          path={RP.uploadPdf}
          element={
            <PrivateRoute>
              <UploadPdf />
            </PrivateRoute>
          }
        />

        <Route
          path={RP.documents}
          element={
            <PrivateRoute>
              <Documents />
            </PrivateRoute>
          }
        />

        <Route
          path={RP.deletedDocuments}
          element={
            <PrivateRoute>
              <DeletedDocuments />
            </PrivateRoute>
          }
        />

        <Route
          path={RP.showSavedQdrantQa}
          element={
            <PrivateRoute>
              <QuestionsAnswersPage />
            </PrivateRoute>
          }
        />

        <Route
          path={RP.show_DeletedQdrantQa}
          element={
            <PrivateRoute>
              <Show_DeletedQdrantQa />
            </PrivateRoute>
          }
        />
        <Route path={RP.Profile} element = {<Profile />} />
      </Route>
    </Routes>
  );
};
export default AppRoute;
